import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";

import Alert from '@mui/material/Alert';
import { Button, Divider,TextField, Grid, Typography, Box,CircularProgress } from "@mui/material"

import {getWorkerStruct, setData} from './WorkerStruct'
import { updateTextValue, handleSubmit,updateValue,updateSelectedValue} from '../../core/js/FormUtils'
import {createAPI, updateAPI, getAPI, updateEditableAPI} from './WorkerAPI';
import {CoreContext} from "../../core/context/CoreContext";

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {validMobileNumberEntry, validNameEntry, validEmailEntry} from '../../core/js/FormValidation';

import {getPathVariable} from '../../core/js/UrlUtils';
import { useSearchParams } from "react-router-dom";
import RadioForBoolean from '../../core/form/RadioForBoolean';
import MyDate from '../../core/components/MyDate';
import { useDispatch,useSelector } from 'react-redux';
import { updateWorkerObj,addWorkerObj, setShowEditForWorker} from 'store/slice/ManufSlice';
import { setApiInProgress } from 'store/slice/HeaderSlice';
import { setMessage } from 'store/slice/HeaderSlice';



export default function WorkerEditForm(){
    const dispatch = useDispatch();
    const [formValues, setFormValues] = useState(getWorkerStruct);
    const [showError, setShowError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('Something went wrong');
    const [dataLoaded, setDataLoaded] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    
    const {workerDashboard} = useSelector((state)=>state.manufslice);
    const [workerId, setWorkerId] = useState(workerDashboard.selectedId);
    const { businessid } = useSelector((state) => state.headerslice.userprofileInfo)
        
    const {skillList} = useSelector((state)=>state.manufslice);
    const handleDynamicSelectedValueForskillid = (e) =>{
        updateSelectedValue(formValues, setFormValues,e, 
            'skillname', e.target.value==0?'Select Item':skillList.find(obj => obj.id === e.target.value).title);
    }

    const {apiInProgress} = useSelector((state)=>state.headerslice)
    useEffect(()=>{
    },[apiInProgress])

    useEffect(() => {
        if (workerId!==-1) {
            if (dataLoaded) return;
            getAPI(workerId, loadForm);
        }
        else {
           // formValues.<<CONTEXT>>.value=searchParams.get('<<CONTEXT>>');
            setDataLoaded(true);
        }

        setFormValues({
            ...formValues,
            ['businessid']: {
                ...formValues['businessid'],
                value: businessid
            }
        })
    },[]);

    const setNotification = (message) => {
        dispatch(setMessage(message));
    }
    const loadForm = (data)=>{
        setData(data, formValues, setFormValues);
        setDataLoaded(true);
    }
    const handleRadioChange = (name, value) => {
        setShowError(false);
        console.log(value+" == "+getRadioAPIvalue(value))
        updateValue(formValues, setFormValues, name, getRadioAPIvalue(value));
    }
    const getRadioValue = (value) => {
        if (value ) 
            return "yes"
        else 
            return "no"
    }
    const getRadioAPIvalue = (value) => {
        if (value ==="yes") 
            return true
        else 
            return false
    }
    const handleTextChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;
        // Remove newlines for the description field
        const sanitizedValue = value.replace(/[\r\n]+/g, '')
        updateTextValue(formValues, setFormValues, { target: { name, value: sanitizedValue } });
    }
    const handleDoubleChange = (e) => {
        setShowError(false);
        const { name, value } = e.target;

        // Do not allow starting with '.'
        if (value.startsWith('.')) {
            return;
        }

        // Allow empty string so user can delete all characters
        if (value === '' || value === '.') {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
            return;
        }

        // Regex: Allow up to 9 digits before decimal, optional decimal, up to 2 digits after decimal (Indian Rupees format)
        const regex = /^\d{0,9}(\.\d{0,2})?$/;

        if (regex.test(value)) {
            updateTextValue(formValues, setFormValues, { target: { name, value } });
        }
    }
    const handleNameChange = (e) =>{
        setShowError(false);
        
       if (validNameEntry(e))
        updateTextValue(formValues, setFormValues,e);
    }
    const handleMobileChange = (e) => {
        setShowError(false);
        
       if (validMobileNumberEntry(e))
            updateTextValue(formValues, setFormValues,e);
    }
    const handleEmailidChange = (e) => {
        setShowError(false);
        
       if (validEmailEntry(e))
            updateTextValue(formValues, setFormValues,e);
    }

    const createSuccessCallback = (obj) =>{
         dispatch(setApiInProgress(false));
        dispatch(addWorkerObj(obj));
        setNotification('Record has been cretaed successfully !!!');
        dispatch(setShowEditForWorker(false));
    }
    const updateSuccessCallback = (obj) =>{
         dispatch(setApiInProgress(false));
        dispatch(updateWorkerObj(obj));
        setNotification('Record with id['+workerId+'] has been updated successfully !!!');
        dispatch(setShowEditForWorker(false));
        
    }
    const failuerCallback = (errorMsg) => {
         dispatch(setApiInProgress(false));
        setErrorMsg(errorMsg);
        setShowError(true);
    }
    const callCreateAPI = (formValues, successCallBack, failuerCallback) =>{
        dispatch(setApiInProgress(true));
        createAPI(formValues, successCallBack, failuerCallback);
    }
    const callUpdateAPI = (id,formValues, updateSuccessCallback, failuerCallback) =>{
        dispatch(setApiInProgress(true));
        updateAPI(id,formValues, updateSuccessCallback, failuerCallback);
    }
    const onSubmit=(e)=>{
        handleSubmit(e,workerId, formValues, setFormValues, createSuccessCallback, updateSuccessCallback, failuerCallback, callCreateAPI, callUpdateAPI);
    }
    const setDate = (fieldName, value) => {
        var date = new Date(value);
        
        const day = date.getDate();
        const dayStr = day < 10 ? '0' + day : day.toString();

        const month = date.getMonth() + 1;
        const monthStr = month < 10 ? '0' + month : month.toString();
        var dateStr =date.getFullYear()+ "-" +  monthStr + "-" + dayStr + "T00:00:00.000Z";
        updateValue(formValues, setFormValues, fieldName, dateStr);
    }
    return (
        <form  noValidate onSubmit={onSubmit} >
            <Grid container direction="column" padding={.25}>
                {showError? <Alert severity="error">{errorMsg}</Alert>: ''}
                <Box sx={{ flexGrow: 1 }}>
                    <Grid item sx={{overflowY: "scroll", backgroundColor:'white',maxHeight:'58vh'}}>
                        <Grid container direction="column" padding={.25}>
                            <Grid item>
                                <Typography variant='h4'>{workerId===-1?'Add':'Edit'} Worker List </Typography>
                                <Divider/>
                            </Grid>
                            <Grid height='25px' ></Grid>
                            {dataLoaded?
                                <Grid container display="flex" spacing={2} direction="row" justifyContent="space-between" alignItems="center"> 
                                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.title.placeholder}
                                    required={formValues.title.required}
                                    label={formValues.title.label}
                                    name={formValues.title.name}
                                    value={formValues.title.value}
                                    onChange={handleTextChange}
                                    error={formValues.title.error}
                                    helperText={formValues.title.error && formValues.title.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                   
                            <Grid item lg={4} xs={12}>
                                <FormControl sx={{  width:'100%'}} size="Normal">
                                    <InputLabel id="demo-simple-select-autowidth-label">{formValues.skillid.label}</InputLabel>
                                    <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            label={formValues.skillid.label}
                                            name={formValues.skillid.name}
                                            value={formValues.skillid.value}
                                            onChange={handleDynamicSelectedValueForskillid}
                                            
                                            error={formValues.skillid.error}
                                            helpertext={formValues.skillid.error && formValues.skillid.errorMessage}
                                            >
                                            <MenuItem key={0} value="0">Select Item</MenuItem>
                                            {
                                                skillList && skillList.map((item, i) => <MenuItem key={i} value={item.id}>{item.title}</MenuItem>) 
                                            }
                                        </Select>
                                </FormControl> 
                            </Grid>                        
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.skillname.placeholder}
                                    required={formValues.skillname.required}
                                    label={formValues.skillname.label}
                                    name={formValues.skillname.name}
                                    value={formValues.skillname.value}
                                    onChange={handleTextChange}
                                    error={formValues.skillname.error}
                                    helperText={formValues.skillname.error && formValues.skillname.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                                            
                            <Grid item lg={4} xs={12}>
                                <TextField size="Normal"
                                    placeholder={formValues.typeid.placeholder}
                                    required={formValues.typeid.required}
                                    label={formValues.typeid.label}
                                    name={formValues.typeid.name}
                                    value={formValues.typeid.value}
                                    onChange={handleTextChange}
                                    error={formValues.typeid.error}
                                    helperText={formValues.typeid.error && formValues.typeid.errorMessage}
                                    sx={{width:'100%'}}
                                />
                            </Grid>
                        
                                    <Grid item lg={4} xs={12} sx={{display:'none'}}>
                                        <TextField size="Normal"
                                            placeholder={formValues.businessid.placeholder}
                                            required={formValues.businessid.required}
                                            label={formValues.businessid.label}
                                            name={formValues.businessid.name}
                                            value={formValues.businessid.value}
                                            onChange={handleTextChange}
                                            error={formValues.businessid.error}
                                            helpertext={formValues.businessid.error && formValues.businessid.errorMessage}
                                            sx={{ width: '100%',  }}
                                        />
                                    </Grid> 
                                </Grid>
                            :<></>}
                        </Grid>
                    </Grid>
                </Box>
                <Grid height='25px' ></Grid>
                <Grid padding={1}>
                    <Divider/>
                </Grid>
                <Grid container direction="row" justifyContent="flex-end"  >
                {   apiInProgress?<CircularProgress/>:
                    <>
                        <Button variant="outlined" type="submit" >{workerId===-1?'Add':'Save'}</Button>&nbsp;&nbsp;&nbsp;
                        <Button variant="outlined" onClick={()=>{dispatch(setShowEditForWorker(false));}}>Close</Button>
                    </>
                }
                </Grid>
            </Grid>
        </form>
    );
};